module.exports = __webpack_public_path__ + "img/9788957980927.13592c77.jpg";